import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { STREET } from "../../utils/constants";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_STREETS } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_STREETS, API_VILLAGES } from "../../utils/apis";

export const useStreets = () => {
  const tableColumns = () => [
    createColumn("name", true, "Street Name"),
    createColumn("village_name", true, "Village"),
    createColumn("actions", false),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions actions={[createEditAction(URL_STREETS, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_STREETS);
  const activityFilter = "streets";

  return { tableData, tableColumns, formRoute, activityFilter };
};

export const useStreetForm = () => {
  const { loadData: loadVillageData, data: villagesData } = useGet();
  const { loadData, loading } = useGet();
  useEffect(() => loadData({ api: API_STREETS }), []);

  useEffect(() => loadVillageData({ api: API_VILLAGES }), []);

  const fields: any = [
    {
      field_name: "name",
      label: "Street name",
      type: "text",
      props: { required: true },
    },
    {
      field_name: "parent",
      label: "Village",
      type: "select",
      props: { required: true },
      options_data: villagesData,
      loading,
    },
  ];

  const sections: any = [
    {
      title: "Street details",
      fields,
    },
  ];
  const redirect = getRegister(URL_STREETS);
  const defaultValues = { street_type: STREET };
  return { fields, sections, redirect, defaultValues };
};

export const StreetsForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useStreetForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
